module.exports = __webpack_public_path__ + "static/media/fontAlign.33b66d8e.jpg";